module.exports = __webpack_public_path__ + "static/small-logo-0e8e340a939677cca838193bec0151db.png";